import React from 'react'
import classNames from 'classnames'
import { useDroppable } from '@dnd-kit/core'
import { Draggable } from './draggable'

const classes = classNames(
    'border bg-white text-sm text-center font-medium rounded-full py-1.5',
)

export const WordList = React.forwardRef(({items, draggingId}, ref) => {
    const {setNodeRef} = useDroppable({
        id: 'WordList',
    })

    return (
        <div
            ref={setNodeRef}
            className={'px-2 mx-[-8px]'}
        >
            <div
                className={`grid grid-cols-3 mt-1 mr-[-16px] mb-3`}
                ref={ref}
            >
                {items.map((pairItem, index) =>
                    <Draggable
                        index={index}
                        key={index}
                        fromDroppableId={'WordList'}
                        draggingId={draggingId}
                    >
                        {pairItem.word}
                    </Draggable>
                )}
            </div>
        </div>
    )
})
